<lib-page
  [page]="surveyRenderStore.currentPageState().page!"
  class="block w-full rounded-2xl py-4 md:p-10 transition-all"
  [isValid]="surveyRenderStore.isPageValid()"
  (pageAction)="onPageAction($event)"
>
</lib-page>
<!-- @for (plugin of surveyRenderStore.currentPageState()?.page?.plugins; track -->
@for (pageContainer of [surveyRenderStore.currentPageState().page?.id]; track
pageContainer) {
<div class="plugin-layer">
  @for (plugin of pluginsList(); track plugin.id) {
  <lib-plugin-host #pluginRef [pluginDef]="plugin"></lib-plugin-host>
  }
</div>
}
